<template>
    <div class="mine page">
        <div class="page-bg"></div>
        <div class="wrapper">
            <van-pull-refresh v-model="isLoading" :pulling-text="$t('pullingtext')" :loosing-text="$t('loosingtext')"
                :loading-text="$t('loadingtext')" @refresh="onRefresh">
                <div class="header">
                    <van-nav-bar class="nav-bar">
                        <template #right>
                            <van-image src="img/mine/kf.png" width="35" height="35" @click="toService()"
                                style="margin: 0 10px 0 10px;">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                        </template>
                    </van-nav-bar>
                    <div class="user-wrapper">
                        <img src="@/assets/avatar.png" style="width: 65px; border-radius: 50%;">
                        <div class="login-content">
                            <div class="login-btn">{{ userInfo.tel }}</div>
                            <div class="xinyu">
                                <!-- <img v-if="userInfo.level == 0" src="@/assets/vip0.png" alt=""> -->
                                <img v-if="userInfo.level == 1" src="@/assets/vip1.png" alt="">
                                <img v-if="userInfo.level == 2" src="@/assets/vip2.png" alt="">
                                <img v-if="userInfo.level == 3" src="@/assets/vip3.png" alt="">
                                <img v-if="userInfo.level == 4" src="@/assets/vip4.png" alt="">
                                <span>{{ $t('CreditScore') }}: {{ userInfo.xinyu || 0 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="finance">
                        <!-- <div class="line"></div> -->
                        <div class="finance-item" @click="doWithdrawal()">
                            <van-icon class="icon" :name="require('@/assets/dollar.png')" v-if="$i18n.locale == 'en'" />
                            <van-icon class="icon" :name="require('@/assets/mxn.svg')"
                                v-else-if="$i18n.locale == 'es'" />
                            <van-icon class="icon" :name="require('@/assets/thb.svg')"
                                v-else-if="$i18n.locale == 'th'" />
                            <van-icon class="icon" :name="require('@/assets/mnav2.png')" v-else />
                            <span class="text">{{ $t('redeemPoints') }}</span>
                        </div>
                    </div>
                    <div class="wallet">
                        <div class="part-1 van-hairline--bottom">
                            <div class="flex-1 font-28 font-primary-color">{{ $t('myActivityPoints') }}</div>
                        </div>
                        <div class="part-2">
                            <div class="balance van-ellipsis">{{ userInfo.balance || 0 }}</div>
                            <span class="font-28 font-gray" style="margin-bottom: 40px;">{{ $t('integral') }}</span>
                            <div style="margin-bottom: 40px;" class="refresh-btn" @click="onRefresh()">
                                <van-icon name="replay" color="#000" />
                            </div>
                        </div>
                    </div>
                    <div class="menu">
                        <!-- <div class="menu-item" @click="toSetbank()">
                            <van-image class="menu-item-icon" src="img/mine/nav1.png">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('bankCardInformation') }}</span>
                        </div> -->
                        <div class="menu-item" @click="toPassionateMovies">
                            <van-image class="menu-item-icon" src="img/mine/video.png">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('PassionateMovies') }}</span>
                        </div>
                        <div class="menu-item" @click="toMall">
                            <van-image class="menu-item-icon" src="img/mine/mall.png">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('acshop') }}</span>
                        </div>
                        <div class="menu-item" @click="toLoginPassword()">
                            <van-image class="menu-item-icon" src="img/mine/nav7.png">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('loginPassword') }}</span>
                        </div>
                        <div class="menu-item" @click="toPayPassword()">
                            <van-image class="menu-item-icon" src="img/mine/nav8.png" width="40" height="40">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('paymentPassword') }}</span>
                        </div>
                        <div class="menu-item" @click="$router.push({ path: '/Fundingdetails' });">
                            <van-image class="menu-item-icon" src="img/mine/nav2.png">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('Fundingdetails') }}</span>
                        </div>
                        <div class="menu-item" @click="toNotice()">
                            <van-image class="menu-item-icon" src="img/mine/4.png">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('noticeAnnouncement') }}</span>
                        </div>
                        <div class="menu-item" @click="toService()">
                            <van-image class="menu-item-icon" src="img/mine/kf.png">
                                <template v-slot:loading>
                                    <van-loading type="spinner" />
                                </template>
                            </van-image>
                            <span class="menu-item-label">{{ $t('onlineService') }}</span>
                        </div>
                    </div>
                    <van-button class="sign-out" type="primary" size="normal" @click="loginout()">{{ $t('logOut')
                        }}</van-button>
                </div>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            userInfo: {},
            isLoading: false,
        };
    },
    created() {
        if (localStorage.getItem('token')) {
            this.getUserInfo();
        } else {
            this.$router.push({ path: '/Login' });
        }
    },
    methods: {
        toPayPassword() {
            this.$router.push({ path: '/SetPayPassword' });
        },
        toNotice() {
            if (localStorage.getItem('token')) {
                this.$router.push({ path: '/Notice' })
            } else {
                this.$router.push({ path: '/Login' })
            }
        },
        onRefresh() {
            setTimeout(() => {
                this.isLoading = false;
                if (localStorage.getItem('token')) {
                    this.getUserInfo();
                    this.$toast(this.$t('refreshSuccessful'));
                } else {
                    this.$router.push({ path: '/Login' })
                }
            }, 500);
        },
        doWithdrawal() {
            this.$httpNew({
                method: 'get',
                url: 'get_bank_info'
            }).then(res => {
                if (res.code == 0) {
                    this.$router.push("withdraw");
                } else {
                    // this.$router.push("Setbank");
                    this.$httpNew({
                        method: 'post',
                        data: {
                            username: this.userInfo.tel,
                            bankname: new Date().getTime(),
                            // cardnum: this.cardnum
                        },
                        url: 'set_bank_info'
                    }).then(res => {
                        if (res.code == 0) {
                            this.$router.push("withdraw");
                        }
                    })
                }
            })

        },
        toService() {
            this.$router.push({ path: '/customerservice' });
        },
        toPassionateMovies() {
            let kefu = this.$store.getters.getBaseInfo.line.replace(/\s*/g, "");
            return window.location.href = kefu;
        },
        toMall() {
            this.$router.push({ path: '/Mall' });
        },
        getUserInfo() {
            this.$httpNew({
                method: 'post',
                url: 'get_user_info',
                data: {},
            }).then(res => {
                if (res.code == 0) {
                    this.userInfo = res.user_info || {};
                }
            })
        },
        loginout() {
            localStorage.removeItem("token");
            this.$router.push({ path: '/Login' });
        },
        // toSetbank() {
        //     this.$router.push("Setbank");
        // },
        toLoginPassword() {
            this.$router.push({ path: '/SetLoginPassword' });
        },
        switchLanguage() {
            this.$router.push({ path: '/SwitchLanguage' });
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    background-color: #f2f2f5;
}

.mine {
    position: relative;
    bottom: 10px;
    background: #f2f2f5;
    background: url('~@/assets/usertop.png') no-repeat top -60px center;
    background-size: contain;
    padding-bottom: 50px;
}

.mine .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

}

.nav-bar {
    /* background: linear-gradient(90deg, #7e5678, #e6c3a1); */
    background: content-box;
}

.mine .header {
    /* background: linear-gradient(90deg, #7e5678, #e6c3a1); */
    padding-bottom: 100px;

}

::v-deep .van-nav-bar__content {
    height: 100px;
}

::v-deep .van-hairline--bottom::after {
    border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
    font-size: 45px;
}

.mine .header .user-wrapper {
    display: flex;
    align-items: center;
    margin: 0px 40px 0px 40px;
}

.mine .user_img {
    height: 130px;
    width: 130px;
}

::v-deep .van-loading__spinner {
    height: 50px;
    width: 50px;
}

::v-deep .van-image__error-icon {
    font-size: 70px;
}

.mine .header .user-wrapper .login-content {
    flex: 1;
    margin-left: 30px;
    position: relative;

    .levelBox {
        position: absolute;
        top: 90px;
        left: 125px;
        color: #fff;
        font-weight: bold;
    }
}



.mine .header .user-wrapper .login-content .login-btn {
    font-size: 45px;
    color: #fff;
    margin-bottom: 5px;
    // padding-left: 10px;
}

.xinyu {
    color: #fff;
    display: flex;
    align-items: center;

    >img {
        height: 50px;
        margin-top: 5px;
    }
}

.mine .header .user-wrapper .login-content .login-label {
    margin-top: -13px;
    font-size: 28px;
    color: hsla(0, 0%, 100%, 0.6);
}

.mine .page-bg {
    height: 500px;
    /* background: linear-gradient(90deg, #7e5678, #e6c3a1); */
}

.mine .content {
    position: relative;
    padding: 10px 30px 30px;
    min-height: 500px;
    background-color: #f2f2f5;

    padding-bottom: 180px;

}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    color: #ffffff;
    font-size: 35px;
}

.mine .wrapper .content .finance {
    position: absolute;
    display: flex;
    align-items: center;
    top: -55px;
    left: 30px;
    right: 30px;
    height: 120px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .finance .line {
    width: 3px;
    height: 40px;
    background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.mine .wrapper .content .finance .finance-item .text {
    margin-left: 10px;
    font-size: 28px;
    /* color: #000; */
    /* font-weight: 500; */
    color: #000;
    font-weight: 600;
}

.mine .wrapper .content .finance .finance-item .icon {
    font-size: 50px;
}

.mine .wrapper .content .menu {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 1.5px 1px 0 #e4e4e7;
    padding-bottom: 20px;
    margin-top: 15px;
}

.mine .wrapper .content .menu .menu-item {
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: flex-start; */
    width: 33.33%;
    /* height: 130px; */
    margin-bottom: 10px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
    font-size: 26px;
    /* color: #868686; */
    font-weight: 500;
    text-align: center;
    display: block;
    color: #000;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
    margin: 25px;
    width: 60px;
    height: 60px;
    -o-object-fit: contain;
    object-fit: contain;
    display: block;
    margin: 25px auto;
}

.mine .wrapper .content .wallet {
    margin-top: 80px;
    padding: 0 30px;
    /* background-color: #fff; */
    border-radius: 15px;
    /* box-shadow: 0 1.5px 1px 0 #e4e4e7; */
    background: #000;
    color: #fff;
}

.mine .wrapper .content .wallet .part-1 {
    display: flex;
    align-items: center;
    height: 80px;
    color: #fff;
}

.mine .wrapper .content .wallet .font-primary-color {
    /* color: #000; */
    color: #fff;
}

.font-gray {
    /* color: #868686; */
    color: #fff;
}

.mine .wrapper .content .wallet .part-2 {
    display: flex;
    align-items: center;
    height: 80px;
}

.mine .wrapper .content .wallet .part-2 .balance {
    flex: 1;
    font-size: 60px;
    /* color: #7e5678; */
    font-weight: 700;
    color: #fff;
}

// .mine .wrapper .content .wallet .van-hairline--bottom::after {
//     border-bottom-width: 3px;
// }

.mine .wrapper .content .wallet .part-2 .refresh-btn {
    margin-left: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    font-size: 30px;
    border-radius: 50%;
    color: #ffffff;
    background-color: #fff;
}

.sign-out {
    margin: 80px 0 0 0;
    height: 90px;
    width: 100%;
    line-height: 90px;
    border-radius: 14px;
    color: #fff;
    font-size: 32px;
    font-weight: bolder;
    border: none;
    background: linear-gradient(90deg, #323233, #000000);
}

.needFen {
    font-size: 24px;
    margin-left: 5px;
}
</style>
